import actionTypes from '../../../redux/actionTypes'

export const setPageMetaTagsSingle = (pageMetaTags) => ({
  type: actionTypes.SET_PAGE_META_TAGS_SINGLE,
  payload: pageMetaTags
})
